import { getLanguageFromStorage, triggerAnalyticsEvent, } from "syf-js-utilities";
import { DEFAULTS, PAGE_INFO_PROPS } from "../const/analytics";
import getCorrelationId from "./getCorrelationId";
import { getSFDDLValue } from "../ui/atoms/LoanNickNameModal/helpers";
var triggerAnalytics = function (_a) {
    var _b;
    var _c = _a.product, product = _c === void 0 ? DEFAULTS.PRODUCT : _c, _d = _a.pageFunction, pageFunction = _d === void 0 ? DEFAULTS.PAGE_FUNCTION : _d, _e = _a.pageName, pageName = _e === void 0 ? DEFAULTS.PAGE_NAME : _e, _f = _a.pageSubFunction, pageSubFunction = _f === void 0 ? DEFAULTS.SUB_FUNCTION : _f, _g = _a.message, message = _g === void 0 ? DEFAULTS.MESSAGE : _g, _h = _a.messageType, messageType = _h === void 0 ? DEFAULTS.MESSAGE_TYPE : _h, _j = _a.previouslyVisited, previouslyVisited = _j === void 0 ? DEFAULTS.PREVIOUS_PAGE : _j, _k = _a.errorMessage, errorMessage = _k === void 0 ? "" : _k, _l = _a.clientName, clientName = _l === void 0 ? "" : _l;
    triggerAnalyticsEvent({
        pageFunction: pageFunction,
        messageType: messageType,
        errorMessage: errorMessage,
        message: message,
        pageName: pageName,
        pageSubFunction: pageSubFunction,
        clientName: clientName,
        previouslyVisited: previouslyVisited,
        product: product,
        pageKind: (_b = getSFDDLValue(PAGE_INFO_PROPS.PageKind)) !== null && _b !== void 0 ? _b : DEFAULTS.PAGE_KIND,
        countryLanguage: "us|".concat(getLanguageFromStorage()),
        token: getCorrelationId(),
    });
};
export default triggerAnalytics;
//# sourceMappingURL=triggerAnalytics.js.map